import { render, staticRenderFns } from "./_MasterPending.vue?vue&type=template&id=b0f8e59e&slot=Content&"
import script from "./_MasterPending.vue?vue&type=script&lang=js&"
export * from "./_MasterPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports